(() => {
  const phone = '51965177255';

  const readVariants = (productInfo) => {
    try {
      return JSON.parse(productInfo?.querySelector('[data-velora-variant-stock]')?.textContent || '[]');
    } catch (error) {
      return [];
    }
  };

  const getSelectedOptions = (productInfo) =>
    [...productInfo.querySelectorAll('variant-selects fieldset input:checked, variant-selects select')]
      .map((input) => (input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent : input.value))
      .map((value) => value?.trim())
      .filter(Boolean)
      .join(' / ');

  const openProductWhatsApp = (button) => {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const productInfo = button.closest('product-info');
    const variantId = productInfo?.querySelector('product-form input[name="id"]')?.value;
    const variant = readVariants(productInfo).find((item) => String(item.id) === String(variantId));
    const quantity = productInfo?.querySelector('.quantity__input')?.value || '1';
    const productTitle = button.dataset.productTitle || document.querySelector('h1')?.textContent?.trim() || '';
    const variantTitle = variant?.title || getSelectedOptions(productInfo) || 'Sin variante';
    const priceInCents = Number(variant?.price);
    const price = Number.isFinite(priceInCents)
      ? new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
          priceInCents / 100
        )
      : button.dataset.productPrice || '';
    const baseUrl = button.dataset.productUrl || window.location.href.split('?')[0];
    const productUrl = variantId ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}variant=${variantId}` : baseUrl;
    const message = [
      'Hola Velora 💖 quisiera comprar esta cartera:',
      '',
      `✨ Producto: ${productTitle}`,
      `🎀 Modelo: ${variantTitle}`,
      `📦 Cantidad: ${quantity}`,
      `💰 Precio: S/ ${price}`,
      '',
      'Ver producto:',
      productUrl,
    ].join('\n');

    window.open(
      `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const openCartWhatsApp = async () => {
    const popup = window.open('about:blank', '_blank');
    if (popup) popup.opener = null;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      const cart = await response.json();

      if (!cart.items?.length) {
        popup?.close();
        alert('Tu carrito está vacío.');
        return;
      }

      const lines = ['Hola, Velora 🦜. Vengo de la página web ✨. Quiero comprar:', ''];
      cart.items.forEach((item, index) => {
        lines.push(`👜 ${index + 1}. ${item.product_title}`);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          lines.push(`Color / variante: ${item.variant_title}`);
        }
        lines.push(`Cantidad: ${item.quantity}`);
        lines.push(`Subtotal: S/${(item.final_line_price / 100).toFixed(2)}`, '');
      });
      lines.push(`Total del carrito: S/${(cart.total_price / 100).toFixed(2)}`);
      lines.push('Quiero coordinar pago y envío 💖');

      const url = `https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`;
      if (popup) popup.location.replace(url);
      else window.location.href = url;
    } catch (error) {
      popup?.close();
      console.error('Error al obtener carrito:', error);
      alert('Hubo un problema al abrir WhatsApp.');
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const productButton = event.target.closest('.velora-wa-btn');
      const cartButton = event.target.closest('#veloraCartWA');
      if (!productButton && !cartButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (productButton) openProductWhatsApp(productButton);
      else openCartWhatsApp();
    },
    true
  );
})();
